var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsOptional, IsString } from "class-validator";
export class DocumentDeliveryDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentDeliveryDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentDeliveryDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentDeliveryDto.prototype, "studyId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentDeliveryDto.prototype, "batchId", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], DocumentDeliveryDto.prototype, "createdAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentDeliveryDto.prototype, "createdBatch", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DocumentDeliveryDto.prototype, "delivered", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    __metadata("design:type", Object)
], DocumentDeliveryDto.prototype, "deliveredAt", void 0);
export class CreateDocumentDeliveryInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateDocumentDeliveryInput.prototype, "batchId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateDocumentDeliveryInput.prototype, "studyId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateDocumentDeliveryInput.prototype, "createdBatch", void 0);
